<script>
    export let request = "";

    let isShowRequest = true;

    // HELPER FUNCTIONS
    const _toggleShowHideDetails = () => (isShowRequest = !isShowRequest);
</script>

<div
    class={`transition flex flex-col w-full lg:flex-row ${
        isShowRequest ? "" : "max-h-[50px]"
    }`}
>
    <div
        class="flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex justify-between pr-4 text-white cursor-pointer bg-gradient-to-b from-bg-primary to-bg-secondary"
            on:click|preventDefault={_toggleShowHideDetails}
        >
            <p class="font-bold px-2 py-4">Request</p>
        </div>

        <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex flex-row gap-x-2">
                    {#if request}
                        <pre
                            class="ml-3 pr-3 whitespace-pre-wrap font-sans break-words">{JSON.stringify(
                                JSON.parse(request),
                                undefined,
                                2
                            )}</pre>
                    {:else}
                        <p class="content">No request</p>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .content {
        width: calc(100% - 50px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
